import React, { FC } from 'react';
import { ReviewProps } from '~/core/dto/components/reviewDTO';
import star from '~/assets/icons/Star.svg';

import './Review.styles.css';

const Review: FC<ReviewProps> = ( {
  stars, name, message, emoji,
} ) => (
  <div className={emoji && 'emojiReviewContainer'}>
    {emoji && (
      <div className="emojiTitle">
        <img src={emoji} alt="emoji" />
        <p>{name}</p>
      </div>
    )}
    <div className="reviewContainer">
      <div className="reviewHeader">
        <div className="reviewStars">
          {Array.from( { length: stars }, ( _, i ) => (
            <img key={i} src={star} alt="star" className="active" />
          ) )}
          {Array.from( { length: 5 - stars }, ( _, i ) => (
            <img key={i} src={star} alt="star" />
          ) )}
        </div>
        {!emoji && <p>{name}</p>}
      </div>
      {/* eslint-disable-next-line react/no-danger */}
      <p className="reviewMessage" dangerouslySetInnerHTML={{ __html: message }} />
    </div>
  </div>
);

export default Review;
